import ContactMe from './Contact';
import './Contact.scss';

export default ContactMe;
